<div class="content-height d-lg-block d-none">
    <div class="row h-100">

        <div class="col-6 image-section position-relative">
            <div class="mt-2">
                <div class="d-flex justify-content-between flex-column align-items-center">
                    <apnst-material-stepper class="mb-6" [steps]="steps"></apnst-material-stepper>
                    <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718099024441Working%203d%201.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-primary-faint mb-3">
                        <div class="col-1 faq-primary-div-height mt-n3">
                            <h6 class="rotate-text text-center mt-5 py-2">FAQ</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718099094763College%201.png" alt="">
                            </div>
                            <div class="w-100 mt-2">
                                <h5>What if i have applied to multiple colleges?</h5>
                                <p class="faq-text-size">If you have applied for multiple Colleges/ Universities in different countries, then choose the best university and country you have applied to, while entering the information.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6">
            <div class="container h-100">
                <div>
                    <apnst-common-header [configHeader]="configBasicInformationHeader" [showHeaderWeb]="true" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
                </div>

                <div class="">
                    <aerp-base-schema-form *ngIf="layout && model" [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmit)="onSubmit($event)" [layout]="layout">
                    </aerp-base-schema-form>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="d-lg-none d-block">

    <div class="mt-5">
        <apnst-material-stepper [steps]="steps"></apnst-material-stepper>
    </div>
    <div class="container">

        <div class="">
            <apnst-common-header [configHeader]="configBasicInformationHeader" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
        </div>
        <div class="px-3 px-lg-6">
            <aerp-base-schema-form *ngIf="layout && model" [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmit)="onSubmit($event)" [layout]="layout">
            </aerp-base-schema-form>
        </div>
    </div>
</div>